
























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import iwFloorAreaOffice from "./FloorAreaOffice.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwInputCheckboxGroup: iwInputCheckboxGroup,
        iwFloorAreaOffice: iwFloorAreaOffice
    },
    data: function() {
        return {
            pathInStoreExists: "property.specificities.SME.office.exists",
            pathInStoreFloorAreaOffice: "property.specificities.SME.office.surface",
            checkboxes: [
                {
                    value: "hasOffice",
                    label: "is_there_an_office"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","HOMES_TO_BUILD", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["hasOffice"];
            }
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) || this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreFloorAreaOffice);
        },
        isOpen: function(): boolean {
            let isOpen = false;

            if(this.valueChecked && this.valueChecked.length > 0) {
                isOpen = true;
            }
            return isOpen;
        },
        floorAreaOfficeInput: function(): Vue | void {
            const accordionComponent = this.$refs.floorAreaOffice as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.floorAreaOfficeInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        }
    },
    mounted: function() {
        if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null && this.isDisplayed) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
    },
    methods: {
        updateValueFloorAreaOffice: function(floorAreaOffice: number): void {
            if (floorAreaOffice == 0 && this.$store.getters["FormModule/getValue"](this.pathInStoreFloorAreaOffice) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaOffice);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreFloorAreaOffice, "value": floorAreaOffice});
            }
        },
        updateValue: function(selectedValues:  Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.floorAreaOfficeInput) {
                    this.floorAreaOfficeInput.$data.internalInput = 0;
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaOffice);
            }
        }
    },
});
